import React from "react";
import "./_qokr-okr-details.scss";

// Text of a key result / initiative: board rows carry `{ statement }`, the
// team view (§7.3) plain strings.
const textOf = (item) => (typeof item === "string" ? item : item?.statement);

// The read-only body of one objective everywhere it appears: Key results,
// then Initiatives, statements only (no targets before the lock, as in
// Annual OKRs).
const QokrOkrDetails = ({ keyResults = [], initiatives = [] }) => (
  <div className="qokr-okrd">
    <div className="qokr-okrd__section">
      <span className="qokr-okrd__label">Key results</span>
      {keyResults.length ? (
        <ol className="qokr-okrd__list">
          {keyResults.map((item, index) => (
            <li key={item.key_result_id || index} className="qokr-okrd__item">
              <span className="qokr-okrd__seq">{index + 1}</span>
              <span className="qokr-okrd__text">{textOf(item)}</span>
            </li>
          ))}
        </ol>
      ) : (
        <p className="qokr-okrd__none mb-0">No key results yet.</p>
      )}
    </div>

    {initiatives.length ? (
      <div className="qokr-okrd__section">
        <span className="qokr-okrd__label">Initiatives</span>
        <ol className="qokr-okrd__list">
          {initiatives.map((item, index) => (
            <li key={item.initiative_id || index} className="qokr-okrd__item">
              <span className="qokr-okrd__seq qokr-okrd__seq--init">
                {index + 1}
              </span>
              <span className="qokr-okrd__text">{textOf(item)}</span>
            </li>
          ))}
        </ol>
      </div>
    ) : null}
  </div>
);

export default QokrOkrDetails;
